import {HttpClient, HttpHeaders} from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { CommonState } from '../store/reducer';
import { ENVIRONMENT_TOKEN } from '../../environment/token-variables';

import { Store } from '@ngrx/store';
import {CurrentState} from '../store/current-state';


@Injectable()
export class ErrorLogService {
  private readonly ERROR_URL = `/private/errors`;

  constructor(
    protected http: HttpClient,
    private currentState: CurrentState<CommonState>,
    public store: Store<CommonState>,
    @Inject(ENVIRONMENT_TOKEN) private readonly environment
  ) {
  }

  logFrontendError(type: string, module: string, stage: string, platform: string, userId = null, error: any) {
    const token = this.currentState.snapshot.user.token;
    let headers = new HttpHeaders();
    headers = headers.append('Content-Type', 'application/json');
    headers = headers.append('Authorization', token);

    const options = {
      headers
    };

    if (!userId) {
      userId = this.currentState.snapshot.user.id;
    }

    const body: any = {
      type,
      module,
      stage,
      userId,
      platform,
      message: JSON.stringify(error),
      timestamp: Date.now(),
    };

    const url = this.environment.backend + this.ERROR_URL;

    return this.http.post(url, body, options).subscribe({
      error: (err) => console.warn('Error logging failed:', err)
    });
  }
}
